import { ClientProviderEnum } from "../../../../constants";
import { PageContextUtils } from "../../../../utils";
import { useKambiMenuItemsMobile } from "./Kambi/useKambiMenuItemsMobile";
import { useKambiNumberOfItemsMobile } from "./Kambi/useKambiNumberOfItemsMobile";
import { useSpectateMenuItemsMobile } from "./Spectate/useSpectateMenuItemsMobile";
import { useSpectateNumberOfItemsMobile } from "./Spectate/useSpectateNumberOfItemsMobile";

export const useMobileCategories = trackingInfo => {
  const { name } = PageContextUtils.getClientProviderData();
  const useNumberOfItems =
    name === ClientProviderEnum.Kambi
      ? useKambiNumberOfItemsMobile
      : name === ClientProviderEnum.Spectate
        ? useSpectateNumberOfItemsMobile
        : null;

  useNumberOfItems();

  const useMenuItems =
    name === ClientProviderEnum.Kambi
      ? useKambiMenuItemsMobile
      : name === ClientProviderEnum.Spectate
        ? useSpectateMenuItemsMobile
        : null;

  return useMenuItems(trackingInfo);
};
